module.exports = __webpack_public_path__ + "img/download.57b6bf05.svg";